import { getParamFromUrl } from '@fff-web/fff-utilities';

export const isInvertedGTB = () => getParamFromUrl('planselection') === 'true';
